import type { UserEvent } from "@/services/api/cronos/user/events/get-all"

export default function isARecurringEvent(event: UserEvent): boolean {
  const { parent } = event
  return parent.days.length > 0
}
